import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnlockedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15.127,
	height: 19.855,
	viewBox: "0 0 15.127 19.855",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6734",
		"data-name": "Path 6734",
		d: "M11.564,12.345a1.891,1.891,0,1,0,1.891,1.891A1.9,1.9,0,0,0,11.564,12.345Zm5.673-4.727h-.945V5.727a4.727,4.727,0,0,0-9.3-1.182.947.947,0,0,0,1.834.473,2.834,2.834,0,0,1,5.578.709V7.618H5.891A1.9,1.9,0,0,0,4,9.509v9.455a1.9,1.9,0,0,0,1.891,1.891H17.236a1.9,1.9,0,0,0,1.891-1.891V9.509A1.9,1.9,0,0,0,17.236,7.618Zm0,10.4a.948.948,0,0,1-.945.945H6.836a.948.948,0,0,1-.945-.945V10.455a.948.948,0,0,1,.945-.945h9.455a.948.948,0,0,1,.945.945Z",
		transform: "translate(-4 -1)",
		fill: "#71cf48"
	})
});
export { SvgUnlockedIcon as ReactComponent };
